import React, { useState, useEffect } from "react";
import axios from "axios";
import EmailValidator from "email-validator";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import { Link } from "react-router-dom";
import Headerpage from "src/shared/components/header";
import Footerpage from "src/shared/components/footer";
import { Info } from "@material-ui/icons";
import { Tooltip, Typography } from "@material-ui/core";
import { useNavigationHistory, addToNavigationHistory, getNavigationHistory } from "src/hooks/useNavigationHistory";

const LogInpage: React.FC = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    // const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const publicUrl = process.env.PUBLIC_URL;
    const history = useNavigationHistory();

    // Manually add current path to history when component mounts
    useEffect(() => {
      const currentPath = window.location.pathname;
      addToNavigationHistory(currentPath);
      console.log('Login page mounted, added path to history:', currentPath);
      console.log('Current history after adding:', getNavigationHistory());
    }, []);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        // setError("");
        setLoading(true);

        const EmailValid = EmailValidator.validate(email.trim());
        if (!EmailValid) {
            setLoading(false);
            alert("Please enter a valid email.");
        } else if (EmailValid && password.trim() !== "") {
            try {
                sessionStorage.setItem("isFirstVisit", "true");
                const response = await axios.post(`${publicUrl}/api/user/login`, {
                    email: email.toLowerCase(),
                    password,
                });
            console.log("login response:::::", response)
                if (response?.data?.status === true) {
                    const loginUser = response.data?.data || response.data;
                    sessionStorage.setItem(
                      "is_mask_student_name",
                      String(Boolean(loginUser?.is_mask_student_name))
                    );
                    // alert("Login successful!");
                    localStorage.setItem("token", response.data.token); // Store token
                    
                    // Store user ID for user-specific navigation history
                    if (response.data.userId) {
                        localStorage.setItem("userId", response.data.userId);
                        console.log("Stored user ID:", response.data.userId);
                    }
                    
                    // Debug: Log the full history
                    console.log("Full navigation history:", history);
                    console.log("History length:", history.length);
                    
                    // Get the path before login (2 steps back)
                    const lastPath = history[history.length - 3];
                    console.log("Path before login (lastPath):", lastPath);
                    
                    // Also try to get from localStorage directly
                    const localStorageHistory = getNavigationHistory();
                    console.log("History from localStorage:", localStorageHistory);
                    
                    if (lastPath?.includes("dashboard")) {
                      console.log("Redirecting to dashboard:", lastPath);
                      window.location.href = lastPath;
                    } else {
                      console.log("Redirecting to home (no dashboard path found)");
                      window.location.href = "/";
                    }


                    
                }else{
                    alert(response?.data?.message);
                }
            } catch (err: any) {
                // setError(err.response?.data?.message || "Login failed!");
                alert("Login failed")
            } finally {
                setLoading(false);
            }
        }
    };

    return (<>
    <div>
     <Headerpage/>
                    <div className="container-inner">
              <div className="content-leader" style={{
                width: "100%",
                height: "calc(100vh - 153px)",
                backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/gritp.jpg')})`
              }}>
        <div className="login-main-content">
        <div className="login-inner-main-content">
            <h2 className="login_heading" >Login</h2>

            <form onSubmit={handleLogin} style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px"
            }}>
               
                {/* Test button to add sample navigation history */}
                {/* <button
                    type="button"
                    onClick={() => {
                        // Add some sample paths to test the navigation history
                        addToNavigationHistory('/dashboard');
                        addToNavigationHistory('/dashboard/coaches');
                        addToNavigationHistory('/dashboard/analytics');
                        addToNavigationHistory('/password');
                        console.log('Added sample paths. Current history:', getNavigationHistory());
                    }}
                    style={{
                        padding: "8px",
                        fontSize: "12px",
                        backgroundColor: "#f0f0f0",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer"
                    }}
                >
                    Add Sample Navigation History (for testing)
                </button> */}

                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required={true}
                    autoComplete="off"
                    style={{
                        padding: "12px",
                        fontSize: "16px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        outline: "none"
                    }}
                />
                <div style={{
                    position: "relative"
                }}>
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required={true}
                         autoComplete="new-password"
                        style={{
                            padding: "12px",
                            fontSize: "16px",
                            border: "1px solid #ccc",
                            borderRadius: "6px",
                            outline: "none",
                            width: "100%",
                            boxSizing: "border-box"
                        }}
                    />
                     <Tooltip 
          enterTouchDelay={0} 
          leaveTouchDelay={4000} 
          placement="right"
          title={<Typography style={{ fontSize: "14px" }}>{"If you don’t have a password, click ‘Forgot Password’ to generate one."}</Typography>}
        >
          <Info style={{ position: "absolute", top: "13px", right: "-30px", left: "auto;", marginLeft: 5, fontSize: 25, cursor: "pointer" }} />
        </Tooltip>
                    <span
                        onClick={() => setShowPassword(prev => !prev)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            color: "#555"
                        }}
                    >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                    </span>
                </div>
                {/* {error && <p style={{ color: "red", fontWeight: "bold",marginBottom:"0" }}>{error}</p>} */}
        

                <Link to="/forgot/password" style={{ textAlign: "center", fontSize: "14px", color: "#003366" }}>
                    Forgot password?
                </Link>

                <button
                    type="submit"
                    className="login_button"
                    disabled={loading}
                   
                >
                    {loading ? "Logging in..." : "Login"}
                </button>
            </form>
        </div>
        </div>
        </div>
        </div>
        </div>
        <Footerpage/>
        </>);
};

export default LogInpage;



// WEBPACK FOOTER //
// ./src/features/home/pages/signIn-page/logIn.tsx